import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img src="https://templatefor.net/wp-content/uploads/2019/10/Lost-in-the-Clouds-Error-404.jpg" width="100%" height="600px" alt="" />
        </div>


    );
};

export default NotFound;